module.exports = __webpack_public_path__ + "static/media/everyday_digital_weekend_papers_footy2024.def27aac.png";